import { gql } from 'apollo-boost';

export default gql`
  {
    getPluItems {
      keyIndex
      shortDescription
      longDescription
      allDescriptions
      productGroupCode
      nacsCode
      nacsCodeNote
      createdDate
      modifiedDate
    }
  }
`;
